export default "__VITE_ASSET__C0q0VqaA__"